import { render } from "./Personal.vue?vue&type=template&id=2487987a&ts=true"
import script from "./Personal.vue?vue&type=script&lang=ts"
export * from "./Personal.vue?vue&type=script&lang=ts"

import "./Personal.vue?vue&type=style&index=0&id=2487987a&lang=css"

import exportComponent from "D:\\Work\\IMMS\\IMMSV3\\App\\IMMS.MasterClient\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/Personal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2487987a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2487987a', __exports__)) {
    console.log('reload')
    api.reload('2487987a', __exports__)
  }
  
  module.hot.accept("./Personal.vue?vue&type=template&id=2487987a&ts=true", () => {
    console.log('re-render')
    api.rerender('2487987a', render)
  })

}


export default __exports__